export default class RuleParameters {
  parameterId: string;

  id: string;

  name: string;

  defaultValue: string;

  label: string;

  type: string;

  value: string = '';

  description: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.parameterId = obj.id
    this.name = obj.name || '';
    this.defaultValue = obj.defaultValue || '';
    this.type = obj.type || '';
    this.label = obj.label || '';
    this.defaultValue = obj.defaultValue || '';
    this.value = obj.value || '';
    this.description = obj.description || '';
  }

  public static of(obj: any = {}): RuleParameters {
    return new RuleParameters(obj || {});
  }

  public static ofList(obj: any[]): RuleParameters[] {
    return obj.map(this.of)
  }

  get isMoneyInput(): boolean {
    return this.type === 'MONEY';
  }

  get isMoney2Input(): boolean {
    return this.type === 'MONEY2';
  }

  get isPercentInput(): boolean {
    return this.type === 'PERCENT';
  }

  get isPercent2Input(): boolean {
    return this.type === 'PERCENT2';
  }

  get isLongInput(): boolean {
    return this.type === 'LONG';
  }

  get isRangeInput(): boolean {
    return this.type === 'RANGE';
  }

  get isRange2Input(): boolean {
    return this.type === 'RANGE2';
  }

  get isBooleanInput(): boolean {
    return this.type === 'BOOLEAN';
  }

  get isValid() {
    return (this.isMoneyInput || this.isMoney2Input) && parseFloat(this.value) > 0.0;
  }
}
